var exports = {
  "Qs": "ThemeAcceptModal.module__content___U1VQNG",
  "h_": "ThemeAcceptModal.module__description___U1VQNG",
  "Hy": "ThemeAcceptModal.module__codeContainer___U1VQNG",
  "AS": "ThemeAcceptModal.module__pre___U1VQNG",
  "Y4": "ThemeAcceptModal.module__hljs___U1VQNG",
  "lB": "ThemeAcceptModal.module__codeActions___U1VQNG",
  "vo": "ThemeAcceptModal.module__codeActionsVisible___U1VQNG",
  "cL": "ThemeAcceptModal.module__copyButton___U1VQNG",
  "nJ": "ThemeAcceptModal.module__copyIcon___U1VQNG",
  "KQ": "ThemeAcceptModal.module__loadingText___U1VQNG",
  "kc": "ThemeAcceptModal.module__errorText___U1VQNG",
  "qr": "ThemeAcceptModal.module__footer___U1VQNG",
};

module.exports = exports;
